import { ConfirmationDialog } from "../../../assets/types";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { StateDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";

interface StateViewProps {
  data?: StateDto;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
  regionLookup: DropdownOption[] | undefined;
}
export const StateView = (props: StateViewProps) => {
  const region: string =
    props.regionLookup?.find((r) => r.value === props.data?.regionId)
      ?.display ?? Constants.emptyString;

  const modalDialogProps: VfxDialogProps | undefined =
    new ConfirmationDialog().get(props.onDelete, "Delete", {
      Name: props.data?.name ?? Constants.emptyString,
    });

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      onEdit={props.onEdit}
      title="View State"
      onDelete={props.onDelete}
      modalDialogProps={modalDialogProps}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />
          <DisplayData
            text="Description"
            importedData={props.data?.description}
          />
          <DisplayData
            text="Abbreviation"
            importedData={props.data?.abbreviation}
          />
          <DisplayData text="Capital" importedData={props.data?.capital} />
          <DisplayData text="Region" importedData={region} />
        </>
      )}
    </Drawer.View>
  );
};
